import { apiFetch } from "../useApi";

export default async function deleteDevice({ deviceId }) {
  const response = await apiFetch(`/devices/${deviceId}`, {
    method: 'DELETE',
  });
}
